// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import asyncMergeSort from 'async-merge-sort'

export const sortData = (arr, { asc, col }, callback) => {
  const sorter = (a, b, cb) => {
    let av
    let bv

    switch (col) {
      case 'elevation' :
      case 'overallHeightAmsl' :
        av = +a[col]
        bv = +b[col]
        break

      default :
        av = `${a[col]}`.toLowerCase()
        bv = `${b[col]}`.toLowerCase()
        break
    }

    if (asc) {
      return cb(null, (av >= bv) ? 1 : -1)
    } else {
      return cb(null, (av <= bv) ? 1 : -1)
    }
  }

  return asyncMergeSort(arr, sorter, callback)
}

// based on form's values, determine which column to sort by.
// since GIS is not in place, only sort by ASR number for now
export const getSortColByFormValues = () => 'asr'
